import { type DisplayGlyph, FrameGlyph } from '@/kanjivg/components/frame-glyph'
import { cn } from '@/lib/utils'

/** The anchor's em-box geometry, shared with `GlyphAnchorSkeleton`. */
export const GLYPH_ANCHOR_BOX =
    'aspect-square w-[min(30vh,240px)] md:size-[280px]'

// Row 2 — Practice Surface focal element (spine §3.3). Em-box wrapper at the
// v1.1 amended scale: 30vh mobile capped at min(30vh, 240px); 280px desktop.
// Reduced from v1.0 (40vh/380px) per user feedback that the glyph dominated
// the page; the new register shares weight with the story prose. The
// character fills the box at adjusted font sizes; `leading-none` keeps the
// line-box equal to the em-box so the glyph centers without inheriting
// font-fallback metrics (§2.1). Paper-on-paper — no card surface; no
// vermilion, no glow, no rarity badge; mastery accent off (§11.7 LOCKED).
export function GlyphAnchor({
    character,
    glyph,
}: {
    character: string
    // Optional stroke-slice display glyph (kanji.glyph_from_strokes) — when
    // the stored character is an unfaithful approximation, the surface passes
    // the curated slice and the anchor renders it at the same em-box scale.
    glyph?: DisplayGlyph
}) {
    return (
        <div className="flex justify-center">
            <div
                className={cn(
                    'flex items-center justify-center',
                    GLYPH_ANCHOR_BOX
                )}
            >
                {glyph?.kind === 'svg' ? (
                    <FrameGlyph
                        glyph={glyph}
                        label={character}
                        className="block size-50 text-ink md:size-60"
                    />
                ) : (
                    <span
                        aria-label={character}
                        className="block font-mincho text-[200px] leading-none text-ink md:text-[240px]"
                        style={{ userSelect: 'none' }}
                    >
                        {character}
                    </span>
                )}
            </div>
        </div>
    )
}
